import { Alert } from "react-bootstrap"

   


export const Success  =({message, visible, setVisible}) =>{

    return (
      <>
      {visible && (
        <Alert  variant="success" style={{ height: "50px", width: "auto" ,position: 'relative' }}>
          <p>{message}</p>
          <i
            className="fas fa-times"
            style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}
            onClick={() => setVisible(false)}
          ></i>
        </Alert>
      )}
      </>
    )

}